// extracted by mini-css-extract-plugin
export default {"componentWrapper":"ChangePasswordForm_componentWrapper__ghkUZ","formElement":"ChangePasswordForm_formElement__AUsCu","actions":"ChangePasswordForm_actions__gbF6g"};